import { ProcessingActivityModel } from "../ProcessingActivity.types";
import { useDotLegalQueryClient } from "@common/hooks/dotLegalReactQuery";

export function useUpdateProcessingActivityModel(processingActivityId: string) {
    const queryClient = useDotLegalQueryClient();
    return {
        update: function (updateFunc: (model: ProcessingActivityModel) => void): ProcessingActivityModel {
            let queryKey = "processingActivity" + processingActivityId;
            const model = queryClient.getQueryData<ProcessingActivityModel>(queryKey);
            const newProcessingActivityModel = { ...model! };
            updateFunc(newProcessingActivityModel);
            return newProcessingActivityModel;
        },
    };
}
